// extracted by mini-css-extract-plugin
module.exports = {"pageCrumbs":"styles_pageCrumbs__eb7i8","pageCrumbsWrapper":"styles_pageCrumbsWrapper__4Tag8","pageCrumb":"styles_pageCrumb___Ypu0","pageCrumbLink":"styles_pageCrumbLink__BZWAa"};